import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

const InlineIconX = () => (
  <svg viewBox="0 0 20 20" fill="none">
    <path
      d="M15 5L5 15"
      stroke="var(--color-icon-lineart)"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5L15 15"
      stroke="var(--color-icon-lineart)"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function ModalIcon({
  className,
  type,
  size = 'xsmall',
  ...props
}) {
  switch (type) {
    case 'x':
      return (
        <span
          className={classNames(styles.svgIcon, className, styles[size])}
          {...props}
        >
          <InlineIconX />
        </span>
      );
  }
  return null;
}
